import { connect } from 'react-redux'
import PhotoListComponent from '../components/PhotoListComponent.jsx';
import {
	forwardToFindPhotosByCard
} from '../actions';

const mapStateToProps = (state) => ({
	previousPage: state.getIn(['photoListReducer', 'previousPage']),
	card: state.getIn(['photoListReducer', 'card']),
	clothesPrePhotoList: state.getIn(['photoListReducer', 'clothesPrePhotoList']),
	pantPrePhotoList: state.getIn(['photoListReducer', 'pantPrePhotoList']),
	clothesPostPhotoList: state.getIn(['photoListReducer', 'clothesPostPhotoList']),
	pantPostPhotoList: state.getIn(['photoListReducer', 'pantPostPhotoList'])
})

const mapDispatchToProps = (dispatch) => ({
	findPhotos: (cardId) => {
		dispatch(forwardToFindPhotosByCard(cardId));
	}
})

const PhotoListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(PhotoListComponent)

export default PhotoListContainer;


// WEBPACK FOOTER //
// ./src/containers/PhotoListContainer.jsx